<template>
  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
    location="bottom"
    data-testid="so-snackbar"
  >
    {{ snackbar.text }}
  </v-snackbar>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useSnackbarStore } from "@/stores/snackbar"

  export default defineComponent({
    inheritAttrs: false,
    data() {
      return {
        snackbar: useSnackbarStore(),
      }
    },
  })
</script>
